/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const ShippingBoxCtn = styled.div`
  padding: 16px 32px;
  border-radius: 10px;
  background-color: #f7f9fd;
  font-family: Sofia Pro;
  margin-bottom: 16px;
  .title {
    line-height: 19.2px;
  }
  .description {
    color: #4b5661;
    margin-top: 4px;
    line-height: 19.6px;
    font-size: 14px;
  }
  .status {
    display: flex;
    justify-content: space-between;
    align-items: end;
    .line {
      width: 100%;
      max-width: 298px;
      height: 12px;
      border-radius: 100px;
      position: relative;
      background: #e6ecf2;
      margin-bottom: 18px;
      .percent {
        width: ${props => (props.$percent ? `${props.$percent}%` : '100%')};
        height: 100%;
        background-color: ${props => (!!!props.$isMadPawsStore ? '#227979' : '#1990ba')};
        border-radius: 100px;
        position: absolute;
        top: 0;
        left: 0;
        transition: width 0.3s ease-in-out;
      }
    }
    .boxIcon {
      margin-left: 35px;
      & > svg > path {
        fill: ${props => (!!!props.$isMadPawsStore ? '#227979' : '#1990ba')};
      }
    }
  }
`;
